import React, { useState } from 'react';
import './Appointment.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    preferredDate: '',
    preferredTime: '',
    message: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('https://web-portal-backend-production.up.railway.app/api/forms/submit/primecaredental', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          formData: {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            service: formData.service,
            preferredDate: formData.preferredDate,
            preferredTime: formData.preferredTime,
            message: formData.message,
            formType: 'appointment'
          }
        }),
      });

      if (response.ok) {
        console.log('Form submitted successfully:', formData);
        setIsSubmitted(true);
        
        // Reset form after 3 seconds
        setTimeout(() => {
          setIsSubmitted(false);
          setFormData({
            name: '',
            email: '',
            phone: '',
            service: '',
            preferredDate: '',
            preferredTime: '',
            message: ''
          });
        }, 3000);
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      // You can add error handling UI here if needed
      alert('There was an error submitting your form. Please try again.');
    }
  };

  const services = [
    'General Consultation',
    // Orthodontics
    'Braces',
    // Implants
    'Dental Implants',
    'Implant Repairs',
    'Artificial Bone Graft (Augmentation)',
    'Maxillary Sinus Lift and Sinus Treatment',
    // Cosmetic Dentistry
    'Cosmetic Treatments',
    'Composite Restoration',
    'PFM and Zirconia Crowns',
    'Partial and Complete Dentures',
    // Restorative Dentistry
    'Root Canal Treatment (RCT)',
    'Simple and Surgical Extractions',
    'Impactions and Apicectomies',
    // Periodontics (Gum Treatment)
    'Scaling and Root Planning (SRP)',
    // Oral and Maxillofacial Surgery
    'Soft Tissue Surgeries',
    'Tongue Tie Treatment',
    'Biopsies',
    'Mole and Wart Removal',
    // TMJ and Jaw Disorders
    'TMJ Disorders Treatment',
    // Anesthesia & Sedation Services
    'Conscious Sedation',
    'Anesthesiologist Services'
  ];

  const timeSlots = [
    '3:00 PM', '3:30 PM', '4:00 PM', '4:30 PM',
    '5:00 PM', '5:30 PM', '6:00 PM', '6:30 PM',
    '7:00 PM', '7:30 PM', '8:00 PM', '8:30 PM', 
    '9:00 PM', '9:30 PM'
  ];

  return (
    <section className="contact-us" id="contact">
      <div className="contact-container">
        {/* Header */}
        <div className="contact-header">
          <div className="header-badge">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4M20 8L12 13L4 8V6L12 11L20 6V8Z"/>
            </svg>
            Contact Us
          </div>
          <h2 className="contact-title">Schedule Your Appointment at Prime Care Dental</h2>
          <p className="contact-subtitle">
            Ready to achieve your perfect smile? Schedule your consultation with Dr. Muhammad Junaid and our expert team. 
            We're here to provide comprehensive dental care for you and your family.
          </p>
        </div>

        <div className="contact-content">
          {/* Contact Form */}
          <div className="contact-form-section">
            <div className="form-header">
              <h3>Schedule Your Appointment</h3>
              <p>Fill out the form below and we'll get back to you within 24 hours</p>
            </div>

            {isSubmitted ? (
              <div className="success-message">
                <div className="success-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"/>
                  </svg>
                </div>
                <h4>Thank You!</h4>
                <p>Your appointment request has been submitted. We'll contact you soon to confirm your appointment.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      placeholder="Enter your full name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      placeholder="your.email@example.com"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number *</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                      placeholder="+92 300 1234567"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="service">Service Needed</label>
                    <select
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={handleInputChange}
                    >
                      <option value="">Select a service</option>
                      {services.map((service, index) => (
                        <option key={index} value={service}>{service}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="preferredDate">Preferred Date</label>
                    <input
                      type="date"
                      id="preferredDate"
                      name="preferredDate"
                      value={formData.preferredDate}
                      onChange={handleInputChange}
                      min={new Date().toISOString().split('T')[0]}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="preferredTime">Preferred Time</label>
                    <select
                      id="preferredTime"
                      name="preferredTime"
                      value={formData.preferredTime}
                      onChange={handleInputChange}
                    >
                      <option value="">Select time</option>
                      {timeSlots.map((time, index) => (
                        <option key={index} value={time}>{time}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Additional Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="4"
                    placeholder="Tell us about your specific needs or questions..."
                  ></textarea>
                </div>

                <button type="submit" className="submit-btn">
                  <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z"/>
                  </svg>
                  Send Appointment Request
                </button>
              </form>
            )}
          </div>

          {/* Contact Information */}
          <div className="contact-info-section">
            {/* Clinic Information */}
            <div className="contact-card">
              <div className="card-header">
                <div className="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
                  </svg>
                </div>
                <h4>Prime Care Dental</h4>
              </div>
              <div className="card-content">
                <div className="info-item">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22S19 14.25 19 9C19 5.13 15.87 2 12 2M12 11.5C10.62 11.5 9.5 10.38 9.5 9S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5Z"/>
                  </svg>
                  <div>
                    <strong>Address:</strong>
                    <p>45 F main market Gulberg 2 Lahore</p>
                  </div>
                </div>
                
                <div className="info-item">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"/>
                  </svg>
                  <div>
                    <strong>Phone:</strong>
                    <p>0308 0006494</p>
                  </div>
                </div>
                
                <div className="info-item">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4M20 8L12 13L4 8V6L12 11L20 6V8Z"/>
                  </svg>
                  <div>
                    <strong>Email:</strong>
                    <p>drmjunaid14384@gmail.com</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Working Hours */}
            <div className="contact-card">
              <div className="card-header">
                <div className="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12.5 7V12.25L17 14.92L16.25 16.15L11 13V7H12.5Z"/>
                  </svg>
                </div>
                <h4>Working Hours</h4>
              </div>
              <div className="card-content">
                <div className="hours-list">
                  <div className="hours-item">
                    <span className="day">Daily</span>
                    <span className="time">3:00 PM - 10:00 PM</span>
                  </div>
                  <div className="hours-item emergency">
                    <span className="day">Emergency</span>
                    <span className="time">Call for Availability</span>
                  </div>
                </div>
              </div>
            </div>

          

            {/* Map */}
            <div className="contact-card map-card">
              <div className="card-header">
                <div className="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.5 3L20.34 3.03L15 5.1L9 3L3.36 4.9C3.15 4.97 3 5.15 3 5.38V20.5C3 20.78 3.22 21 3.5 21L3.66 20.97L9 18.9L15 21L20.64 19.1C20.85 19.03 21 18.85 21 18.62V3.5C21 3.22 20.78 3 20.5 3M15 19L9 17V5L15 7V19Z"/>
                  </svg>
                </div>
                <h4>Visit Our Clinic</h4>
              </div>
              <div className="card-content">
                <div className="map-placeholder">
                  <div className="map-content">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22S19 14.25 19 9C19 5.13 15.87 2 12 2M12 11.5C10.62 11.5 9.5 10.38 9.5 9S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5Z"/>
                    </svg>
                    <h4>Prime Care Dental</h4>
                    <p>45 F main market Gulberg 2 Lahore</p>
                  </div>
                </div>
                <a 
                  href="https://maps.app.goo.gl/t6Tjyj8TgTvBcFyF9" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="directions-btn"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M21.71 11.29L12.71 2.29C12.32 1.9 11.69 1.9 11.3 2.29L2.3 11.29C1.91 11.68 1.91 12.32 2.3 12.71L11.3 21.71C11.69 22.1 12.32 22.1 12.71 21.71L21.71 12.71C22.1 12.32 22.1 11.68 21.71 11.29M14 14.5V12.5H10V10.5H14V8.5L17.5 11.5L14 14.5Z"/>
                  </svg>
                  Get Directions
                </a>
              </div>
            </div>
          </div>
        </div>

     
      </div>

      {/* Background Elements */}
      <div className="contact-bg-elements">
        <div className="bg-circle bg-circle-1"></div>
        <div className="bg-circle bg-circle-2"></div>
        <div className="bg-circle bg-circle-3"></div>
      </div>
    </section>
  );
};

export default ContactUs; 